// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: poppins !important;
}

#sidebar .d-flex {
  margin-bottom: 20px;
}

.slogo {
  max-width: 170px;
  margin-left: 10px;
  margin-top: 0px;
}

/*
.dash-can::after {
    display: flex;
    background-color: red;
    left: 0px;
    right: 0px;
    top: 0px;
    content: '';
    bottom: 0px;
    position: absolute;
    z-index: 10000;
}*/
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: #E0E0E0;
}

.b-table th, .b-table td {
  color: #999EA1;
  font-size: 14px;
  font-weight: 400;
  padding-top: 15px;
  padding-bottom: 15px;
}
.b-table td {
  color: #373737;
}

.b-table.prd td {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.section.dashboard {
  margin-top: 1em;
}

.img-pop-up {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.35);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000000000;
}
.img-pop-up img {
  cursor: pointer;
  background: #DDD;
  width: 500px;
  height: auto;
}

.tfl-d {
  width: 24px;
  height: 24px;
}

.info-card {
  border: 0px solid #DDD;
  box-shadow: unset;
}
.info-card h6 {
  color: #12B196;
  font-weight: bolder;
  font-size: 24px;
}

.gsect {
  display: flex;
  background: #fff;
  border: 1px solid #DDD;
  height: 310px;
  width: 100%;
  margin: 25px 0px;
}

.info-card._1 {
  background: rgba(23, 20, 35, 0.05);
}

.info-card._2 {
  background: rgba(246, 173, 77, 0.13);
}

.info-card._3 {
  background: rgb(245, 255, 255);
}

.info-card._4 {
  background: rgba(18, 177, 150, 0.05);
}

.filter-section {
  margin: 30px 0px;
}

.sub-section {
  display: flex;
  width: 100%;
  padding: 25px;
  margin: 30px 0px;
  background: #fff;
  flex-direction: column;
  border: 1px solid #DDD;
}
.sub-section label {
  margin-bottom: 5px;
}
.sub-section.igb {
  padding: 0px;
}
.sub-section.igb label.laspn {
  margin-top: 15px;
  margin-left: 25px;
  margin-right: 25px;
}
.sub-section.igb .input-group {
  border-top: 1px solid #E0E0E0;
  padding-top: 10px;
  padding-left: 25px;
  padding-right: 15px;
}

.form-group .msa {
  margin-left: 15px !important;
  margin-right: 0px;
  border-radius: 5px !important;
  min-width: 125px;
  padding-left: 20px;
  padding-right: 20px;
}
.form-group .msa.flx {
  margin-left: 0px !important;
  margin-top: 25px;
}
.form-group .msa.alt {
  margin-left: 0px !important;
  margin-top: 0px !important;
}
.form-group .input-group-text {
  background: transparent;
  color: #999EA1;
}

.alert {
  position: fixed;
  top: 20px;
  z-index: 1000000000;
  right: 20px;
}

.fl-rw {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.slogo-rw {
  height: 116px;
  width: 116px;
  margin-top: 1em;
  background: #D9D9D9;
  border: 1px solid #DDD;
}

.bli {
  font-size: 16px;
  cursor: pointer;
  margin-left: 25px;
  background: transparent;
}
.bli.dl {
  color: #FB1F1F;
}

.trbl {
  color: #151515;
  text-decoration: none !important;
  border-bottom: 1px solid #151515;
}
.trbl a {
  color: inherit;
  text-decoration: none !important;
}

.btn {
  height: 45px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-right: 20px; */
  border-radius: 7px;
  border: 0px;
  box-shadow: none !important;
  outline: none !important;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.filter-section .btn {
  margin-right: 20px;
}

.rsv {
  color: #12B196;
}

.trsd {
  color: #151515;
}

.btn-success, .btn-secondary.suc:hover, .btn-secondary.suc.active {
  background: #12B196;
  border: 1px solid #12B196;
}

.btn-secondary.suc {
  border: 0px solid !important;
}

.btn-secondary {
  color: #999EA1;
  background: #EEEEEE;
}

.pagetitle .btn {
  line-height: unset !important;
}
.pagetitle div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.sbtab {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 45px;
  display: flex;
  margin-left: -20px;
  flex-direction: row;
}
.sbtab div {
  border: 1px solid #E0E0E0;
  border-left: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 45px;
  justify-content: center;
  width: calc(50% - 0px);
  text-align: center;
  cursor: pointer;
}
.sbtab div > * {
  color: #000 !important;
  text-decoration: none !important;
}
.sbtab div img {
  margin-right: 10px;
  width: 20px;
}
.sbtab div.nh {
  border-right: 0px;
}
.sbtab div.nh img {
  width: 18px;
}

.cspan1 {
  width: 40%;
}

.cspan2 {
  width: 65%;
}

.text-black {
  color: #000;
}

.info-card.alt {
  height: 220px;
  border: 1px solid #E0E0E0;
}
.info-card.alt h5 {
  font-size: 16px;
  color: #373737;
}
.info-card.alt h6 {
  font-size: 32px;
}

.envid {
  width: 100%;
  display: flex;
  margin: 1em 0;
  flex-direction: row;
  justify-content: center;
}
.envid > div {
  background: #000;
  border-radius: 5px;
  height: auto;
  width: 100%;
  padding-top: 6px;
  min-height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.divi-d {
  display: flex;
  margin-top: 25px;
  margin-bottom: 25px;
  width: 100%;
}
.divi-d div {
  width: 100%;
  height: 1px;
  background: #E0E0E0;
}

.col-l {
  padding: 5px 0px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.col-l strong {
  color: #373737;
  font-size: 16px;
}
.col-l select {
  border: 0px;
  background: transparent;
}

.rspan {
  color: #999EA1;
}

.skk {
  color: #151515;
  position: relative;
  top: -2px;
  margin-left: 8px;
  border: 0px;
  background-color: transparent !important;
}

.skk-d {
  color: #FB1F1F;
  cursor: pointer;
  border: 0px;
  background-color: transparent !important;
  border-bottom: 1px solid #FB1F1F;
}

.opac-2 {
  opacity: 0.25;
}

.info-card.alt .span {
  font-size: 14px;
  color: #999EA1;
}
.info-card.alt ._w {
  margin-top: 15px;
  width: fit-content;
  margin-bottom: 15px;
}
.info-card.alt .card-body {
  display: flex;
  padding: 5px 20px;
  flex-direction: column;
}
.info-card.alt .btn-success {
  background: #12B196;
}
.info-card.alt .card-title {
  margin-top: 5px !important;
  padding-top: 5px !important;
}
.info-card.alt .mpm {
  cursor: pointer;
  color: #151515;
  width: fit-content;
  border-bottom: 1px solid #151515;
}

td .pdc {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
}
td .pdc img {
  width: 47px;
  height: 47px;
  border: 1px solid #DDD;
  cursor: pointer;
}
td .pdc div {
  display: flex;
  margin-left: 1em;
  flex-direction: column;
  justify-content: center;
}
td .pdc div.noi {
  margin-left: 0px;
}
td .pdc div b {
  font-size: 16px;
  color: #373737;
  font-weight: 400;
}
td .pdc div span {
  font-weight: 400;
  font-size: 14px;
  margin-top: 5px;
  color: #999EA1;
}

.icrow {
  display: flex;
  flex-direction: row;
}

.filter-section.mt0 {
  margin-top: 0px !important;
}

.fcol {
  display: inline-flex;
  flex-direction: column;
  padding: 10px 0px;
  width: calc(100% - 175px);
}
.fcol strong {
  font-size: 18px;
  font-weight: 400;
  color: #151515;
}
.fcol .rspan {
  margin-top: 10px;
}

.btn-default.b1 {
  border: 1px solid #12B196 !important;
  margin-top: 20px;
}

.mtp {
  margin-top: 1em;
}

.flx-b {
  display: flex;
  flex-direction: row;
}
.flx-b input {
  width: calc(100% - 35px);
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.flx-b .perc-1 {
  width: 35px;
  height: 38px;
  display: inline-flex;
  justify-content: center;
  border: 1px solid #DDD;
  align-items: center;
  border-left: 0px;
  color: 14px;
}

.balt {
  background-color: rgba(45, 156, 219, 0.2);
  border-left: 5px solid #2D9CDB;
}

.sub-section.balt {
  padding: 25px 15px;
}
.sub-section.balt b {
  display: flex;
  font-size: 14px;
  color: #2D9CDB;
  margin-bottom: 5px;
}
.sub-section.balt span {
  display: flex;
  font-size: 10px;
}
.sub-section.balt span._14 {
  font-size: 14px;
}
.sub-section.balt ul {
  padding-left: 10px;
}
.sub-section.balt ul li {
  font-size: 10px;
}

label.laspn {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1em;
}
label.laspn span {
  display: inline-flex;
}
label.laspn span:first-child {
  width: calc(100% - 175px - 25px);
}
label.laspn span:not(:first-child) {
  margin-left: 5px;
}

.btf {
  display: flex;
  width: 100%;
}

label {
  font-family: "Source Sans 3", sans-serif;
  font-size: 16px;
}
label strong, label b {
  font-size: 20px;
  font-family: "Source Sans 3", sans-serif;
}

.btn-oo {
  top: 7px;
  right: 8px;
  color: #999EA1;
  padding: 3px 10px;
  position: absolute;
  font-size: 12px;
  z-index: 1000;
  background-color: #F4F4F4;
  border-radius: 1em !important;
}

.coupon-div {
  display: flex;
  flex-direction: row;
}
.coupon-div > a {
  width: 376px;
  height: 376px;
  display: inline-flex;
  margin: 10px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  background-color: #F6AD4D;
}
.coupon-div > a span {
  color: #fff;
  font-size: 32px;
}
.coupon-div > a:first-child {
  margin-left: 0px;
  background-color: #12B196;
}

.iw_fill {
  width: 280px;
  position: relative;
  margin-left: 15px;
}
.iw_fill.au {
  width: 100%;
  margin-left: 0px;
}
.iw_fill input {
  height: 45px;
}
.iw_fill .sp_i {
  pointer-events: none;
  position: absolute;
  right: 1em;
  top: 12px;
}
.iw_fill .sp_i i {
  font-size: 22px;
  opacity: 0.75;
}

.gsect {
  height: auto;
  overflow: hidden;
}
.gsect #chart {
  display: flex;
  width: 100% !important;
}

.smwi {
  width: 626px;
  margin-left: calc((100% - 626px) / 2);
}

.App-body.container.main-body .smwi {
  margin-left: 0px !important;
}

.ppv {
  width: 100%;
  height: 127px;
  margin-top: 10px;
  border-radius: 8px;
  display: flex;
  padding: 25px;
  flex-direction: row;
  border: 1px solid #E0E0E0;
}
.ppv .pvd {
  display: flex;
  flex-direction: column;
  margin-left: 1.2em;
}
.ppv .pvd span {
  margin-top: 10px;
  font-size: 14px;
}
.ppv .pvd span a {
  color: #2D9CDB;
  text-decoration: none !important;
}
.ppv .pvd span.gry {
  color: #999EA1;
}

.tgib {
  width: 100%;
  display: flex;
  margin-top: 1em;
  justify-content: space-between;
}
.tgib img {
  width: calc(25% - 10px);
}

.spt {
  margin-top: -12px;
}
.spt > span {
  font-size: 12px;
}

.h200 {
  height: 200px;
  resize: none;
}

.w225 {
  width: 225px;
}

.sub-section.alt {
  background-color: transparent !important;
  border: 0px !important;
  padding: 0px;
}

.flex-e {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.btn-default.b1.alt {
  border-color: #151515 !important;
}

.form-check-input {
  cursor: pointer;
}

.del-p {
  border: 1px solid #DDD;
  background: #eee;
  font-size: 14px;
  padding: 3px 7px;
  border-radius: 8px;
  cursor: pointer;
}

.form-switch .form-check-input:not(:checked) {
  background-color: #D6D6D6;
}

.form-check-input:checked {
  background-color: #12b196;
  border-color: #12b196;
}

.dlabel {
  margin-bottom: 5px;
  justify-content: space-between;
  display: flex;
}

.flexc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

._disab_ i, ._disab_ span {
  opacity: 0.5;
}

.pro-btn {
  position: absolute;
  right: 25px;
  background: purple;
  color: #fff;
  height: 25px;
  border: 0px;
  font-size: 14px;
  width: 40px;
  align-items: center;
  justify-content: center;
  display: flex;
  border: 2px solid #fff;
  border-radius: 2em;
}

.con-pop-up {
  display: none;
  position: fixed;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.35);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: 250ms ease-in-out all;
  z-index: 1000000000;
}

.con-pop-up.active {
  display: flex;
}

.con-pop {
  cursor: pointer;
  background: #DDD;
  padding: 25px;
  width: 350px;
  display: flex;
  flex-direction: column !important;
  height: auto;
}

.con-pop-up.withdrw .con-pop {
  background: #fff !important;
  width: 500px;
  padding: 30px !important;
  position: relative;
  border-radius: 6px;
}

.mod_cancel {
  position: absolute;
  right: 25px;
  top: 25px;
  width: 25px;
  height: 25px;
}

.con-pop-up.withdrw .con-pop strong {
  font-size: 25px;
  font-weight: 500;
  margin-bottom: 10px;
}

.con-pop-up.withdrw .con-pop p {
  font-size: 16px;
  margin-bottom: 15px;
}

.pay_type {
  height: 45px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-left: 1em;
  padding-right: 1em;
  margin: 6px 0px;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
}

.con-pop.ps-1 .pay_type {
  height: 70px;
  cursor: pointer;
  padding-left: 55px;
  position: relative;
  background: #fff;
}
.con-pop.ps-1 .pay_type i {
  position: absolute;
  left: 20px;
  top: 14px;
}
.con-pop.ps-1 .pay_type ul {
  margin-bottom: 0px;
  padding-left: 16px;
  list-style: square;
}

.con-pop.ps-1 .pay_type:hover {
  background: #f0f0f0;
}

.con-pop.ps-1 .pay_type.adnp {
  padding-left: 0px;
  height: 56px;
  border: 0px;
  margin-top: -5px;
  background: #fff !important;
}

.con-pop.ps-2 .form-group, .con-pop.ps-3 .form-group {
  margin-bottom: 10px;
}
.con-pop.ps-2 .form-group label, .con-pop.ps-3 .form-group label {
  margin-bottom: 0.5em;
}
.con-pop.ps-2 .form-group input, .con-pop.ps-2 .form-group select, .con-pop.ps-3 .form-group input, .con-pop.ps-3 .form-group select {
  height: 45px !important;
}
.con-pop.ps-2 .form-group ._ro, .con-pop.ps-3 .form-group ._ro {
  background: #fbfafa !important;
}
.con-pop.ps-2 > b, .con-pop.ps-3 > b {
  color: #000;
  font-size: 32px;
  margin-top: -10px;
  margin-bottom: 10px;
}

.payt_btn {
  height: 45px;
  width: 100%;
  display: flex;
  font-size: 16px;
  margin-top: 12px;
  color: #fff;
  border: 1px solid #12B196;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  background-color: #12B196;
}

button.payt_btn {
  border-radius: 12px;
}

.con-pop strong {
  font-size: 20px;
  margin-bottom: 10px;
}

.con-pop .con-btns {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.con-pop .con-btns button {
  margin-right: 10px;
  margin-left: 10px;
  height: 35px;
  cursor: pointer;
  border: 1px solid #d0c3c3;
  padding-left: 10px;
  padding-right: 10px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #E9E9ED;
  border-radius: 4px;
  font-size: 16px;
}

.mt10 {
  position: relative;
  top: 12px;
}

.anpi {
  font-size: 25px;
  color: #12B196;
}

.anps {
  margin-left: 6px;
}

.sidebar-shadow {
  display: none;
}

@media (max-width: 1199px) {
  #sidebar.show {
    left: 0px !important;
    z-index: 1000;
  }
  .sidebar-shadow {
    background-color: rgba(0, 0, 0, 0.2901960784);
    z-index: 100;
    position: fixed;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
  }
  .sidebar-shadow.show {
    display: flex;
  }
}
.mob-hamburg {
  background: transparent;
  border: 1px solid #DDD;
  margin-right: 5px;
  height: 40px;
  width: 40px;
  font-size: 30px;
  border: 0px;
  cursor: pointer;
  margin-top: -5px;
}
.mob-hamburg.flyin {
  top: 15px;
  left: 15px;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/Dashboard.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;;;;;;;;;;;EAAA;AAaA;EACI,4BAAA;AAAJ;;AAII;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AADR;AAGI;EACI,cAAA;AADR;;AAMI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;AAHR;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;AAJJ;AAMI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAJR;;AAQA;EACI,WAAA;EACA,YAAA;AALJ;;AAQA;EACI,sBAAA;EACA,iBAAA;AALJ;AAOI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;AALR;;AASA;EACI,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AANJ;;AASA;EACI,kCAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,8BAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,gBAAA;AANJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AANJ;AAQI;EACI,kBAAA;AANR;AASI;EACI,YAAA;AAPR;AAQQ;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AANZ;AAQQ;EACI,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AANZ;;AAYI;EACI,4BAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AATR;AAUQ;EACI,2BAAA;EACA,gBAAA;AARZ;AAUQ;EACI,2BAAA;EACA,0BAAA;AARZ;AAWI;EACI,uBAAA;EACA,cAAA;AATR;;AAaA;EACI,eAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAVJ;;AAcA;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AAXJ;AAYI;EACI,cAAA;AAVR;;AAcA;EACI,cAAA;EACA,gCAAA;EACA,gCAAA;AAXJ;AAYI;EACI,cAAA;EACA,gCAAA;AAVR;;AAeA;EACI,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,wBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;;AAgBI;EACI,kBAAA;AAbR;;AAiBA;EACI,cAAA;AAdJ;;AAiBA;EACI,cAAA;AAdJ;;AAiBA;EACI,mBAAA;EACA,yBAAA;AAdJ;;AAiBA;EACI,4BAAA;AAdJ;;AAiBA;EACI,cAAA;EACA,mBAAA;AAdJ;;AAkBI;EACI,6BAAA;AAfR;AAiBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAfR;;AAmBA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAhBJ;AAiBI;EACI,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAfR;AAgBQ;EACI,sBAAA;EACA,gCAAA;AAdZ;AAgBQ;EACI,kBAAA;EACA,WAAA;AAdZ;AAgBQ;EACI,iBAAA;AAdZ;AAeY;EACI,WAAA;AAbhB;;AAmBA;EACI,UAAA;AAhBJ;;AAmBA;EACI,UAAA;AAhBJ;;AAmBA;EACI,WAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,yBAAA;AAhBJ;AAkBI;EACI,eAAA;EACA,cAAA;AAhBR;AAmBI;EACI,eAAA;AAjBR;;AAqBA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBJ;AAoBI;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EAEA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBR;;AA6BA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AA1BJ;AA4BI;EACI,WAAA;EACA,WAAA;EACA,mBAAA;AA1BR;;AA8BA;EACI,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AA3BJ;AA6BI;EACI,cAAA;EACA,eAAA;AA3BR;AA8BI;EACI,WAAA;EACA,uBAAA;AA5BR;;AAgCA;EACI,cAAA;AA7BJ;;AAgCA;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,wCAAA;AA7BJ;;AAgCA;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;EACA,gCAAA;AA7BJ;;AAgCA;EACI,aAAA;AA7BJ;;AAiCI;EACI,eAAA;EACA,cAAA;AA9BR;AAgCI;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;AA9BR;AAgCI;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;AA9BR;AAgCI;EACI,mBAAA;AA9BR;AAgCI;EACI,0BAAA;EACA,2BAAA;AA9BR;AAgCI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;AA9BR;;AAkCA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AA/BJ;AAiCI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AA/BR;AAkCI;EACI,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;AAhCR;AAiCQ;EACI,gBAAA;AA/BZ;AAiCQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AA/BZ;AAiCQ;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AA/BZ;;AAoCA;EACI,aAAA;EACA,mBAAA;AAjCJ;;AAqCI;EACI,0BAAA;AAlCR;;AAsCA;EACI,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AAnCJ;AAqCI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAnCR;AAqCI;EACI,gBAAA;AAnCR;;AAuCA;EACI,oCAAA;EACA,gBAAA;AApCJ;;AAuCA;EACI,eAAA;AApCJ;;AAuCA;EACI,aAAA;EACA,mBAAA;AApCJ;AAqCI;EACI,wBAAA;EACA,4BAAA;EACA,+BAAA;AAnCR;AAqCI;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAnCR;;AAuCA;EACI,yCAAA;EACA,8BAAA;AApCJ;;AAuCA;EACI,kBAAA;AApCJ;AAqCI;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAnCR;AAqCI;EACI,aAAA;EACA,eAAA;AAnCR;AAoCQ;EACI,eAAA;AAlCZ;AAqCI;EACI,kBAAA;AAnCR;AAoCQ;EACI,eAAA;AAlCZ;;AAuCA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AApCJ;AAsCI;EACI,oBAAA;AApCR;AAqCQ;EACI,gCAAA;AAnCZ;AAqCQ;EACI,gBAAA;AAnCZ;;AA0CA;EACI,aAAA;EACA,WAAA;AAvCJ;;AA0CA;EACI,wCAAA;EACA,eAAA;AAvCJ;AAwCI;EACI,eAAA;EACA,wCAAA;AAtCR;;AA0CA;EACI,QAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,6BAAA;AAvCJ;;AA0CA;EACI,aAAA;EACA,mBAAA;AAvCJ;AAyCI;EACI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;AAvCR;AAwCQ;EACI,WAAA;EACA,eAAA;AAtCZ;AAwCQ;EACI,gBAAA;EACA,yBAAA;AAtCZ;;AA2CA;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;AAxCJ;AA0CI;EACI,WAAA;EACA,gBAAA;AAxCR;AA2CI;EACI,YAAA;AAzCR;AA2CI;EACI,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAzCR;AA0CQ;EACI,eAAA;EACA,aAAA;AAxCZ;;AA6CA;EACI,YAAA;EACA,gBAAA;AA1CJ;AA2CI;EACI,aAAA;EACA,sBAAA;AAzCR;;AA6CA;EACI,YAAA;EACA,qCAAA;AA1CJ;;AA8CI;EACI,2BAAA;AA3CR;;AA+CA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AA5CJ;AA8CI;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AA5CR;AA6CQ;EACI,gBAAA;EACA,eAAA;AA3CZ;AA4CY;EACI,cAAA;EACA,gCAAA;AA1ChB;AA4CY;EACI,cAAA;AA1ChB;;AAgDA;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AA7CJ;AA8CI;EACI,uBAAA;AA5CR;;AAgDA;EACI,iBAAA;AA7CJ;AA8CI;EACI,eAAA;AA5CR;;AAgDA;EACI,aAAA;EACA,YAAA;AA7CJ;;AAgDA;EACI,YAAA;AA7CJ;;AAgDA;EACI,wCAAA;EACA,sBAAA;EACA,YAAA;AA7CJ;;AAgDA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AA7CJ;;AAgDA;EACI,gCAAA;AA7CJ;;AAgDA;EACI,eAAA;AA7CJ;;AAgDA;EACI,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA7CJ;;AAgDA;EACI,yBAAA;AA7CJ;;AAgDA;EACE,yBAAA;EACA,qBAAA;AA7CF;;AAgDA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;AA7CA;;AAgDA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA7CJ;;AAgDA;EACI,YAAA;AA7CJ;;AAgDA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AA7CJ;;AAmDA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iCAAA;EACA,mBAAA;AAhDJ;;AAmDA;EACC,aAAA;AAhDD;;AAmDA;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,YAAA;AAhDJ;;AAmDA;EACI,2BAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AAhDJ;;AAmDA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAhDJ;;AAmDA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAhDJ;;AAmDA;EACI,eAAA;EACA,mBAAA;AAhDJ;;AAmDA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAhDJ;;AAmDA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAhDJ;AAiDI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;AA/CR;AAiDI;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AA/CR;;AAmDA;EACI,mBAAA;AAhDJ;;AAmDA;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAhDJ;;AAoDI;EACI,mBAAA;AAjDR;AAkDQ;EACI,oBAAA;AAhDZ;AAkDQ;EACI,uBAAA;AAhDZ;AAkDQ;EACI,8BAAA;AAhDZ;AAmDI;EAEI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAlDR;;AAsDA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AAnDJ;;AAsDA;EACI,mBAAA;AAnDJ;;AAsDA;EACC,eAAA;EACG,mBAAA;AAnDJ;;AAsDA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;AAnDD;;AAsDA;EACC,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAnDD;;AAsDA;EACI,kBAAA;EACA,SAAA;AAnDJ;;AAsDA;EACI,eAAA;EACA,cAAA;AAnDJ;;AAsDA;EACI,gBAAA;AAnDJ;;AAsDA;EACI,aAAA;AAnDJ;;AAsDA;EACI;IACI,oBAAA;IACA,aAAA;EAnDN;EAqDE;IACI,6CAAA;IACA,YAAA;IACA,eAAA;IACA,SAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EAnDN;EAoDM;IACI,aAAA;EAlDV;AACF;AAsDA;EACI,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AApDJ;AAsDI;EACI,SAAA;EACA,UAAA;EACA,kBAAA;AApDR","sourcesContent":["body {\n    font-family: poppins !important;\n}\n\n#sidebar .d-flex {\n    margin-bottom: 20px;\n}\n\n.slogo {\n    max-width: 170px;\n    margin-left: 10px;\n    margin-top: 0px;\n}\n\n/*\n.dash-can::after {\n    display: flex;\n    background-color: red;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    content: '';\n    bottom: 0px;\n    position: absolute;\n    z-index: 10000;\n}*/\n\n.table > :not(:last-child) > :last-child > * {\n    border-bottom-color: #E0E0E0;\n}\n\n.b-table {\n    th, td {\n        color: #999EA1;\n        font-size: 14px;\n        font-weight: 400;\n        padding-top: 15px;\n        padding-bottom: 15px;\n    }\n    td {\n        color: #373737;\n    }\n}\n\n.b-table.prd {\n    td {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.section.dashboard {\n    margin-top: 1em;\n}\n\n.img-pop-up {\n    display: flex;\n    position: fixed;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.35);\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000000000;\n\n    img {\n        cursor: pointer;\n        background: #DDD;\n        width: 500px;\n        height: auto;\n    }\n}\n\n.tfl-d {\n    width: 24px;\n    height: 24px;\n}\n\n.info-card {\n    border: 0px solid #DDD;\n    box-shadow: unset;\n\n    h6 {\n        color: #12B196;\n        font-weight: bolder;\n        font-size: 24px;\n    }\n}\n\n.gsect {\n    display: flex;\n    background: #fff;\n    border: 1px solid #DDD;\n    height: 310px;\n    width: 100%;\n    margin: 25px 0px;\n}\n\n.info-card._1 {\n    background: rgba(23, 20, 35, 0.05);\n}\n\n.info-card._2 {\n    background: rgba(246, 173, 77, 0.13);\n}\n\n.info-card._3 {\n    background: rgba(245, 255, 255, 1);\n}\n\n.info-card._4 {\n    background: rgba(18, 177, 150, 0.05);\n}\n\n.filter-section {\n    margin: 30px 0px;\n}\n\n.sub-section {\n    display: flex;\n    width: 100%;\n    padding: 25px;\n    margin: 30px 0px;\n    background: #fff;\n    flex-direction: column;\n    border: 1px solid #DDD;\n\n    label {\n        margin-bottom: 5px;\n    }\n\n    &.igb {\n        padding: 0px;\n        label.laspn {\n            margin-top: 15px;\n            margin-left: 25px;\n            margin-right: 25px;\n        }\n        .input-group {\n            border-top: 1px solid #E0E0E0;\n            padding-top: 10px;\n            padding-left: 25px;\n            padding-right: 15px;\n        }\n    }\n}\n\n.form-group {\n    .msa {\n        margin-left: 15px !important;\n        margin-right: 0px;\n        border-radius: 5px !important;\n        min-width: 125px;\n        padding-left: 20px;\n        padding-right: 20px;\n        &.flx {\n            margin-left: 0px !important;\n            margin-top: 25px;\n        }\n        &.alt {\n            margin-left: 0px !important;\n            margin-top: 0px !important;\n        }\n    }\n    .input-group-text {\n        background: transparent;\n        color: #999EA1;\n    }\n}\n\n.alert {\n    position: fixed;\n    top: 20px;\n    z-index: 1000000000;\n    right: 20px;\n}\n\n.fl-rw {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.slogo-rw {\n    height: 116px;\n    width: 116px;\n    margin-top: 1em;\n    background: #D9D9D9;\n    border: 1px solid #DDD;\n    // border-radius: 50% !important;\n}\n\n.bli {\n    font-size: 16px;\n    cursor: pointer;\n    margin-left: 25px;\n    background: transparent;\n    &.dl {\n        color: #FB1F1F;\n    }\n}\n\n.trbl {\n    color: #151515;\n    text-decoration: none !important;\n    border-bottom: 1px solid #151515;\n    a {\n        color: inherit;\n        text-decoration: none !important;\n    }\n}\n\n    \n.btn {\n    height: 45px;\n    padding-left: 20px;\n    padding-right: 20px;\n    /* margin-right: 20px; */\n    border-radius: 7px;\n    border: 0px;\n    box-shadow: none !important;\n    outline: none !important;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.filter-section {\n    .btn {\n        margin-right: 20px;\n    }\n}\n\n.rsv {\n    color: #12B196;\n}\n\n.trsd {\n    color: #151515;\n}\n\n.btn-success, .btn-secondary.suc:hover, .btn-secondary.suc.active {\n    background: #12B196;\n    border: 1px solid #12B196;\n}\n\n.btn-secondary.suc {\n    border: 0px solid !important;\n}\n\n.btn-secondary {\n    color: #999EA1;\n    background: #EEEEEE;\n}\n\n.pagetitle {\n    .btn {\n        line-height: unset !important;\n    }\n    div {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n    }\n}\n\n.sbtab {\n    position: absolute;\n    bottom: 0px;\n    width: 100%;\n    height: 45px;\n    display: flex;\n    margin-left: -20px;\n    flex-direction: row;\n    div {\n        border: 1px solid #E0E0E0;\n        border-left: 0px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        height: 45px;\n        justify-content: center;\n        width: calc(50% - 0px);\n        text-align: center;\n        cursor: pointer;\n        &>* {\n            color: #000 !important;\n            text-decoration: none !important;\n        }\n        img {\n            margin-right: 10px;\n            width: 20px;\n        }\n        &.nh {\n            border-right: 0px;\n            img {\n                width: 18px;\n            }\n        }\n    }\n}\n\n.cspan1 {\n    width: 40%;\n}\n\n.cspan2 {\n    width: 65%;\n}\n\n.text-black {\n    color: #000;\n}\n\n.info-card.alt {\n    height: 220px;\n    border: 1px solid #E0E0E0;\n\n    h5 {\n        font-size: 16px;\n        color: #373737;\n    }\n\n    h6 {\n        font-size: 32px;\n    }\n}\n\n.envid {\n    width: 100%;\n    display: flex;\n    margin: 1em 0;\n    flex-direction: row;\n    justify-content: center;\n\n    & > div {\n        background: #000;\n        border-radius: 5px;\n        height: auto;\n        width: 100%;\n        padding-top: 6px;\n        // padding: 1em;\n        min-height: 350px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        // img {\n        //     cursor: pointer;\n        //     height: 50px;\n        //     width: 50px;\n        // }\n    }\n}\n\n.divi-d {\n    display: flex;\n    margin-top: 25px;\n    margin-bottom: 25px;\n    width: 100%;\n\n    div {\n        width: 100%;\n        height: 1px;\n        background: #E0E0E0;\n    }\n}\n\n.col-l {\n    padding: 5px 0px 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    strong {\n        color: #373737;\n        font-size: 16px;\n    }\n\n    select {\n        border: 0px;\n        background: transparent;\n    }\n}\n\n.rspan {\n    color: #999EA1;\n}\n\n.skk {\n    color: #151515;\n    position: relative;\n    top: -2px;\n    margin-left: 8px;\n    border: 0px;\n    background-color: transparent !important;\n}\n\n.skk-d {\n    color: #FB1F1F;\n    cursor: pointer;\n    border: 0px;\n    background-color: transparent !important;\n    border-bottom: 1px solid #FB1F1F;\n}\n\n.opac-2 {\n    opacity: 0.25;\n}\n\n.info-card.alt {\n    .span {\n        font-size: 14px;\n        color: #999EA1;\n    }\n    ._w {\n        margin-top: 15px;\n        width: fit-content;\n        margin-bottom: 15px;\n    }\n    .card-body {\n        display: flex;\n        padding: 5px 20px;\n        flex-direction: column;\n    }\n    .btn-success {\n        background: #12B196;\n    }\n    .card-title {\n        margin-top: 5px !important;\n        padding-top: 5px !important;\n    }\n    .mpm {\n        cursor: pointer;\n        color: #151515;\n        width: fit-content;\n        border-bottom: 1px solid #151515;\n    }\n}\n\ntd .pdc {\n    display: flex;\n    cursor: pointer;\n    flex-direction: row;\n    align-items: center;\n\n    img {\n        width: 47px;\n        height: 47px;\n        border: 1px solid #DDD;\n        cursor: pointer;\n    }\n\n    div {\n        display: flex;\n        margin-left: 1em;\n        flex-direction: column;\n        justify-content: center;\n        &.noi {\n            margin-left: 0px;\n        }\n        b {\n            font-size: 16px;\n            color: #373737;\n            font-weight: 400;\n        }\n        span {\n            font-weight: 400;\n            font-size: 14px;\n            margin-top: 5px;\n            color: #999EA1;\n        }\n    }\n}\n\n.icrow {\n    display: flex;\n    flex-direction: row;\n}\n\n.filter-section {\n    &.mt0 { \n        margin-top: 0px !important;\n    }\n}\n\n.fcol {\n    display: inline-flex;\n    flex-direction: column;\n    padding: 10px 0px;\n    width: calc(100% - 175px);\n\n    strong {\n        font-size: 18px;\n        font-weight: 400;\n        color: #151515;\n    }\n    .rspan {\n        margin-top: 10px;\n    }\n}\n\n.btn-default.b1 {\n    border: 1px solid #12B196 !important;\n    margin-top: 20px;\n}\n\n.mtp {\n    margin-top: 1em;\n}\n\n.flx-b {\n    display: flex;\n    flex-direction: row;\n    input {\n        width: calc(100% - 35px);\n        border-top-right-radius: 0px;\n        border-bottom-right-radius: 0px;\n    }\n    .perc-1 {\n        width: 35px;\n        height: 38px;\n        display: inline-flex;\n        justify-content: center;\n        border: 1px solid #DDD;\n        align-items: center;\n        border-left: 0px;\n        color: 14px;\n    }\n}\n\n.balt {\n    background-color: rgba(45, 156, 219, 0.2);\n    border-left: 5px solid #2D9CDB;\n}\n\n.sub-section.balt {\n    padding: 25px 15px;\n    b {\n        display: flex;\n        font-size: 14px;\n        color: #2D9CDB;\n        margin-bottom: 5px;\n    }\n    span {\n        display: flex;\n        font-size: 10px;\n        &._14 {\n            font-size: 14px;\n        }\n    }\n    ul {\n        padding-left: 10px;\n        li {\n            font-size: 10px;\n        }\n    }\n}\n\nlabel.laspn {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    margin-bottom: 1em;\n\n    span {\n        display: inline-flex;\n        &:first-child {\n            width: calc(100% - 175px - 25px);\n        }\n        &:not(:first-child) {\n            margin-left: 5px;\n        }\n    }\n}\n\n// coupons-page\n\n.btf {\n    display: flex;\n    width: 100%;\n}\n\nlabel {\n    font-family: \"Source Sans 3\", sans-serif;\n    font-size: 16px;\n    strong, b {\n        font-size: 20px;\n        font-family: \"Source Sans 3\", sans-serif;\n    }\n}\n\n.btn-oo {\n    top: 7px;\n    right: 8px;\n    color: #999EA1;\n    padding: 3px 10px;\n    position: absolute;\n    font-size: 12px;\n    z-index: 1000;\n    background-color: #F4F4F4;\n    border-radius: 1em !important;\n}\n\n.coupon-div {\n    display: flex;\n    flex-direction: row;\n\n    &>a {\n        width: 376px;\n        height: 376px;\n        display: inline-flex;\n        margin: 10px;\n        align-items: center;\n        justify-content: center;\n        text-decoration: none;\n        cursor: pointer;\n        background-color: #F6AD4D;\n        span {\n            color: #fff;\n            font-size: 32px;\n        }\n        &:first-child {\n            margin-left: 0px;\n            background-color: #12B196;\n        }\n    }\n}\n\n.iw_fill {\n    width: 280px;\n    position: relative;\n    margin-left: 15px;\n\n    &.au {\n        width: 100%;\n        margin-left: 0px;\n    }\n\n    input {\n        height: 45px;\n    }\n    .sp_i {\n        pointer-events: none;\n        position: absolute;\n        right: 1em;\n        top: 12px;\n        i {\n            font-size: 22px;\n            opacity: .75;\n        }\n    }\n}\n\n.gsect {\n    height: auto;\n    overflow: hidden;\n    #chart {\n        display: flex;\n        width: 100% !important;\n    }\n}\n\n.smwi {\n    width: 626px;\n    margin-left: calc((100% - 626px) / 2);\n}\n\n.App-body.container.main-body {\n    .smwi {\n        margin-left: 0px !important;\n    }\n}\n\n.ppv {\n    width: 100%;\n    height: 127px;\n    margin-top: 10px;\n    border-radius: 8px;\n    display: flex;\n    padding: 25px;\n    flex-direction: row;\n    border: 1px solid #E0E0E0;\n\n    .pvd {\n        display: flex;\n        flex-direction: column;\n        margin-left: 1.2em;\n        span {\n            margin-top: 10px;\n            font-size: 14px;\n            a {\n                color: #2D9CDB;\n                text-decoration: none !important;\n            }\n            &.gry {\n                color: #999EA1;\n            }\n        }\n    }\n}\n\n.tgib {\n    width: 100%;\n    display: flex;\n    margin-top: 1em;\n    justify-content: space-between;\n    img {\n        width: calc(25% - 10px);\n    }\n}\n\n.spt {\n    margin-top: -12px;\n    &>span {\n        font-size: 12px;\n    }\n}\n\n.h200 {\n    height: 200px;\n    resize: none;\n}\n\n.w225 {\n    width: 225px;\n}\n\n.sub-section.alt {\n    background-color: transparent !important;\n    border: 0px !important;\n    padding: 0px;\n}\n\n.flex-e {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.btn-default.b1.alt {\n    border-color: #151515 !important;\n}\n\n.form-check-input {\n    cursor: pointer;\n}\n\n.del-p {\n    border: 1px solid #DDD;\n    background: #eee;\n    font-size: 14px;\n    padding: 3px 7px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.form-switch .form-check-input:not(:checked) {\n    background-color: #D6D6D6;\n}\n\n.form-check-input:checked {\n  background-color: #12b196;\n  border-color: #12b196;\n}\n\n.dlabel {\nmargin-bottom: 5px;\njustify-content: space-between;\ndisplay: flex;\n}\n\n.flexc {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n._disab_ i, ._disab_ span {\n    opacity: 0.5;\n}\n\n.pro-btn {\n    position: absolute;\n    right: 25px;\n    background: purple;\n    color: #fff;\n    height: 25px;\n    border: 0px;\n    font-size: 14px;\n    width: 40px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    border: 2px solid #fff;\n    border-radius: 2em;\n}\n\n\n\n\n.con-pop-up {\n    display: none;\n    position: fixed;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.35);\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transition: 250ms ease-in-out all;\n    z-index: 1000000000;\n}\n\n.con-pop-up.active {\n\tdisplay: flex;\n}\n\n.con-pop {\n    cursor: pointer;\n    background: #DDD;\n    padding: 25px;\n    width: 350px;\n    display: flex;\n    flex-direction: column !important;\n    height: auto;\n}\n\n.con-pop-up.withdrw .con-pop {\n    background: #fff !important;\n    width: 500px;\n    padding: 30px !important;\n    position: relative;\n    border-radius: 6px;\n}\n\n.mod_cancel {\n    position: absolute;\n    right: 25px;\n    top: 25px;\n    width: 25px;\n    height: 25px;\n}\n\n.con-pop-up.withdrw .con-pop strong {\n    font-size: 25px;\n    font-weight: 500;\n    margin-bottom: 10px;\n}\n\n.con-pop-up.withdrw .con-pop p {\n    font-size: 16px;\n    margin-bottom: 15px;\n}\n\n.pay_type {\n    height: 45px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding-left: 1em;\n    padding-right: 1em;\n    margin: 6px 0px;\n    flex-direction: column;\n    border-radius: 4px;\n    border: 1px solid #EAEAEA;\n}\n\n.con-pop.ps-1 .pay_type {\n    height: 70px;\n    cursor: pointer;\n    padding-left: 55px;\n    position: relative;\n    background: #fff;\n    i {\n        position: absolute;\n        left: 20px;\n        top: 14px;\n    }\n    ul {\n        margin-bottom: 0px;\n        padding-left: 16px;\n        list-style: square;\n    }\n}\n\n.con-pop.ps-1 .pay_type:hover {\n    background: #f0f0f0;\n}\n\n.con-pop.ps-1 .pay_type.adnp {\n    padding-left: 0px;\n    height: 56px;\n    border: 0px;\n    margin-top: -5px;\n    background: #fff !important;\n}\n\n.con-pop.ps-2, .con-pop.ps-3 {\n    .form-group {\n        margin-bottom: 10px;\n        label {\n            margin-bottom: .5em;\n        }\n        input, select {\n            height: 45px !important;\n        }\n        ._ro {\n            background: #fbfafa !important;\n        }\n    }\n    &>b {\n        // color: #999EA1;\n        color: #000;\n        font-size: 32px;\n        margin-top: -10px;\n        margin-bottom: 10px;\n    }\n}\n\n.payt_btn {\n    height: 45px;\n    width: 100%;\n    display: flex;\n    font-size: 16px;\n    margin-top: 12px;\n    color: #fff;\n    border: 1px solid #12B196;\n    border-radius: 4px;\n    justify-content: center;\n    align-items: center;\n    background-color: #12B196;\n}\n\nbutton.payt_btn {\n    border-radius: 12px;\n}\n\n.con-pop strong {\n\tfont-size: 20px;\n    margin-bottom: 10px;\n}\n\n.con-pop .con-btns {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: flex-end;\n}\n\n.con-pop .con-btns button {\n\tmargin-right: 10px;\n\tmargin-left: 10px;\n\theight: 35px;\n\tcursor: pointer;\n\tborder: 1px solid #d0c3c3;\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: #E9E9ED;\n\tborder-radius: 4px;\n\tfont-size: 16px;\n}\n\n.mt10 {\n    position: relative;\n    top: 12px;\n}\n\n.anpi {\n    font-size: 25px;\n    color: #12B196;\n}\n\n.anps {\n    margin-left: 6px;\n}\n\n.sidebar-shadow {\n    display: none;\n}\n\n@media (max-width: 1199px) {\n    #sidebar.show {\n        left: 0px !important;\n        z-index: 1000;\n    }\n    .sidebar-shadow {\n        background-color: #0000004a;\n        z-index: 100;\n        position: fixed;\n        left: 0px;\n        top: 0px;\n        right: 0px;\n        bottom: 0px;\n        width: 100%;\n        height: 100%;\n        &.show {\n            display: flex;\n        }\n    }\n}\n\n.mob-hamburg {\n    background: transparent;\n    border: 1px solid #DDD;\n    margin-right: 5px;\n    height: 40px;\n    width: 40px;\n    font-size: 30px;\n    border: 0px;\n    cursor: pointer;\n    margin-top: -5px;\n\n    &.flyin {\n        top: 15px;\n        left: 15px;\n        position: absolute;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
